import React from 'react'

const EmailRead = () => {
  return (
    <div>
        <h1><center>Coming Soon...</center></h1>
    </div>
  )
}

export default EmailRead